import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function noLimitPriceBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        No limit price provided for{' '}
        {parsedStatusObj.symbol ? parsedStatusObj.symbol : ''} limit order.
      </Body3>
    </td>
  );
}
